import { func, bool, string, node } from 'prop-types';
import { Button as BootstrapButton } from 'react-bootstrap';
import './styles.scss';

// Helper function para mapear props personalizadas a React Bootstrap
const mapButtonProps = (color, fill, size) => {
  // Mapeo de colores a variantes de Bootstrap
  const variantMapping = {
    'primary': fill === 'outline' ? 'outline-primary' : 'primary',
    'secondary': fill === 'outline' ? 'outline-secondary' : 'secondary',
    'success': fill === 'outline' ? 'outline-success' : 'success',
    'danger': fill === 'outline' ? 'outline-danger' : 'danger',
    'warning': fill === 'outline' ? 'outline-warning' : 'warning',
    'info': fill === 'outline' ? 'outline-info' : 'info',
    'light': fill === 'outline' ? 'outline-light' : 'light',
    'dark': fill === 'outline' ? 'outline-dark' : 'dark'
  };

  // Mapeo de colores especiales
  const normalizedColor = color === 'error' ? 'danger' : color;

  // Mapeo de tamaños
  const sizeMapping = {
    'large': 'lg',
    'medium': null,
    'small': 'sm',
    'smaller': 'sm',
    'icon': 'sm'
  };

  return {
    variant: variantMapping[normalizedColor] || 'primary',
    size: sizeMapping[size] || null
  };
};

const GridActions = ({
  onSearch = null,
  onClearFilters,
  onExport = null,
  onView = null,
  onManageColumns = null,
  onToggleFilters,
  showExport = true,
  showResults = false,
  totalItems = 0,
  loading = false,
  exportButtonText = 'Exportar',
  viewButtonText = 'Vista',
  manageColumnsButtonText = 'Administrar columnas',
  disabled = false,
  className = '',
  children = null,
  hasFilters = true,
  showSearchInput = false,
  searchValue = '',
  onSearchChange = null,
  searchPlaceholder = 'Buscar...',
  searchInputClassName = '',
  onKeyDown = null,
  title = ''
}) => {
  return (
    <div className={`grid-actions-section ${className}`}>
      {/* Título y controles en la misma fila */}
      {(title || showSearchInput) && (
        <div className="grid-actions-header-row">
          {title && (
            <div className="grid-actions-title">
              <h1>{title}</h1>
            </div>
          )}

          <div className="grid-actions-header-controls">
            {/* Input de búsqueda */}
            {showSearchInput && (
              <div className="grid-search-input-wrapper">
                <div className="input-group grid-search-input-group">
                  <input
                    type="text"
                    className={`optimized-input-field form-control ${searchInputClassName}`}
                    placeholder={searchPlaceholder}
                    value={searchValue}
                    onChange={onSearchChange}
                    onKeyDown={onKeyDown}
                    disabled={disabled}
                  />
                  <BootstrapButton
                    variant="primary"
                    type="button"
                    onClick={onSearch}
                    disabled={disabled}
                    className="grid-search-button"
                  >
                    <i className="bi bi-search"></i>
                  </BootstrapButton>
                </div>
              </div>
            )}

            {/* Botón de filtros */}
            {hasFilters && (
              <BootstrapButton
                type="button"
                variant="primary"
                onClick={onToggleFilters}
                disabled={disabled}
                className="rounded"
              >
                <i className="bi bi-funnel"></i>
              </BootstrapButton>
            )}

            {/* Botón de limpiar filtros */}
            {hasFilters && (
              <BootstrapButton
                type="button"
                {...mapButtonProps('secondary', 'outline')}
                onClick={onClearFilters}
                disabled={disabled}
                className="rounded"
              >
                <i className="bi bi-x-circle"></i>
                {' '}Limpiar
              </BootstrapButton>
            )}
          </div>
        </div>
      )}

      <div className="grid-actions-grid">
        <div className="grid-filters-toggle">
          {!loading && (
            <span className="records-count">{`Se encontraron ${totalItems} registros`}</span>
          )}
        </div>

        <div className="grid-main-actions">
          <div className='buttons'>
            {/* Botón de exportar - acción importante */}
            {showExport && showResults && (
              <BootstrapButton
                type="button"
                {...mapButtonProps('primary', 'full')}
                onClick={onExport}
                disabled={disabled}
                className="rounded"
              >
                <i className="bi bi-arrow-down-circle-fill mx-2" /> {exportButtonText}
              </BootstrapButton>
            )}

            {/* Botón de vista - acción secundaria */}
            {onView && (
              <BootstrapButton
                type="button"
                {...mapButtonProps('primary', 'outline')}
                onClick={onView}
                disabled={disabled}
                className="rounded"
              >
                <span className="bi bi-table"> </span> {viewButtonText}
              </BootstrapButton>
            )}

            {/* Botón de administración - acción terciaria */}
            {onManageColumns && (
              <BootstrapButton
                type="button"
                {...mapButtonProps('primary', 'full')}
                onClick={onManageColumns}
                disabled={disabled}
                className="rounded"
              >
                <span className="bi bi-gear"> </span> {manageColumnsButtonText}
              </BootstrapButton>
            )}
          </div>

          {children}
        </div>
      </div>
    </div>
  );
};

GridActions.propTypes = {
  onSearch: func,
  onClearFilters: func.isRequired,
  onExport: func,
  onView: func,
  onManageColumns: func,
  onToggleFilters: func.isRequired,
  showExport: bool,
  showResults: bool,
  totalItems: node,
  loading: bool,
  searchButtonText: string,
  clearFiltersButtonText: string,
  exportButtonText: string,
  viewButtonText: string,
  manageColumnsButtonText: string,
  disabled: bool,
  className: string,
  children: node,
  showSearchInput: bool,
  searchValue: string,
  onSearchChange: func,
  searchPlaceholder: string,
  searchInputClassName: string,
  onKeyDown: func,
  title: string
};



export default GridActions;
